import type { NextPage } from 'next';
import NewsGridComponent from '../../components/news/news-grid';
import { getNews, News } from '../../models/dtos';

type Props = {
	news: News[];
};

const NewsPage: NextPage<Props> = ({ news }) => {
	return (
		<div className="container">
			<div>
				<h1 className="text-3xl dark:text-gray-200">
					Las últimas noticias sobre finanzas y economía en general.
				</h1>
				<h2 className="text-xl	dark:text-gray-200">
					A continuación te mostramos las últimas noticias mas interesantes que encontrarás.
				</h2>
			</div>
			<NewsGridComponent news={news} />
		</div>
	);
};

export async function getStaticProps() {
	return {
		props: {
			news: getNews(),
			title: 'Últimas noticias de coches'
		}
	};
}

export default NewsPage;
